import React from "react";
import { Box } from "@mui/material";
import { CreatePageList } from "@app/components/Layouts/PageList";
import { Add } from "@app/components/Actions";
import { CustomDataGrid } from "@app/components";
import { useNavigate } from "react-router-dom";
import { GridRowParams } from "@mui/x-data-grid";
import pathRoutes from "../../routes/pathRoutes";
import FilterBackground from "./components/FilterBackground";
import { columnsBackground } from "./utils/background.columns";
import { useBackground } from "./utils/useBackground";
import { PermissionComponentGate } from "@app/utils/PermissionComponentGate";
import { RolesTypes } from "../users/utils/helpers";
import usePermission from "@app/context/PermissionContext";

const BackgroundList = () => {
  const { filteredBackground } = useBackground();
  const dataBackground = filteredBackground();
  const navigate = useNavigate();
  const { isAdmin, isSuperAdmin } = usePermission();

  const handleRowDoubleClick = (params: GridRowParams): void => {
    if (isAdmin || isSuperAdmin)
      navigate(`${pathRoutes.ADMIN_FONDOS}/editar/${params.id}`);
  };
  return (
    <CreatePageList
      title="Listado de fondos"
      buttonRight={
        <PermissionComponentGate
          permissions={[RolesTypes.ADMIN, RolesTypes.SUPER_ADMIN]}
        >
          <Add to={`admin/fondos/nuevo`} title="Nuevo fondo" />
        </PermissionComponentGate>
      }
    >
      <FilterBackground />
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column", mt: 1 }}>
        <CustomDataGrid
          rows={dataBackground}
          columns={columnsBackground}
          search={false}
          handleRowDoubleClick={handleRowDoubleClick}
        />
      </Box>
    </CreatePageList>
  );
};

export default BackgroundList;
